'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlUserinfo = require('./validateUrlUserinfo');

var _validateUrlUserinfo2 = _interopRequireDefault(_validateUrlUserinfo);

var _validateUrlUnicodeHost = require('./validateUrlUnicodeHost');

var _validateUrlUnicodeHost2 = _interopRequireDefault(_validateUrlUnicodeHost);

var _validateUrlPort = require('./validateUrlPort');

var _validateUrlPort2 = _interopRequireDefault(_validateUrlPort);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validateUrlUnicodeAuthority = (0, _regexSupplant2.default)( // $1 userinfo
'(?:(#{validateUrlUserinfo})@)?' + // $2 host
'(#{validateUrlUnicodeHost})' + // $3 port
'(?::(#{validateUrlPort}))?', {
  validateUrlUserinfo: _validateUrlUserinfo2.default,
  validateUrlUnicodeHost: _validateUrlUnicodeHost2.default,
  validateUrlPort: _validateUrlPort2.default
}, 'i');
exports.default = validateUrlUnicodeAuthority;
module.exports = exports['default'];